import { CaseExpense } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceCaseExpenseAction, deleteCaseExpenseAction, deleteCaseExpensesAction, setCaseExpensesAction } from '../reducers/caseExpenseReducer';

export const useCaseExpenseActions = () => {

    const dispatch = useAppDispatch();

    const addOrReplaceCaseExpense = (expense: CaseExpense) => {
        dispatch(addOrReplaceCaseExpenseAction(expense));
    }

    const setCaseExpenses = (expenses: CaseExpense[]) => {
        dispatch(setCaseExpensesAction(expenses));
    }

    const removeCaseExpense = (expenseId: string) => {
        dispatch(deleteCaseExpenseAction(expenseId));
    }

    const removeCaseExpenses = (expenseIds: string[]) => {
        dispatch(deleteCaseExpensesAction(expenseIds));
    }

    return { addOrReplaceCaseExpense, setCaseExpenses, removeCaseExpense, removeCaseExpenses };
}
